import tw from 'twin.macro'

/**
 * The one button shape every rail entry (item, back link, collapse toggle) takes in both states.
 *
 * Expanded it fills the rail, icon at the left; collapsed it is a 36px square centred in the
 * 60px strip. The icon must sit at exactly 8px from the button's edge in every variant so it
 * is centred in the square and does not shift when an item becomes active: the `white` variant
 * carries a 1px border that the `grey` one lacks, so every entry gets a 1px border (transparent
 * on grey) and 7px of padding — 1 + 7 = 8 either way. Only the button's right edge moves during
 * the collapse; the label is dropped from the DOM while collapsed and is revealed or clipped by
 * the rail's own width animation. `mx-auto` keeps the square centred even if the rail's
 * scrollbar steals a gutter.
 */
export const sideNavEntryStyles = (isCollapsed: boolean, isActive = false) => {
  return [
    tw`min-w-0 justify-start overflow-hidden border border-solid px-[7px] hover:bg-shades-50 transition-[width] duration-200 ease-in-out motion-reduce:transition-none`,
    !isActive && tw`border-transparent hover:border-transparent active:border-transparent`,
    isCollapsed ? tw`mx-auto w-[36px]` : tw`w-full`,
  ]
}
